import filter from 'lodash/filter';

import {IntermediatePart} from "../../intermediatePart";
import Config from "../../../../../config";
import { Vanity } from "../../parts/vanity";
import {METADATA} from "../../constants";

export default class VanityFaucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_faucet';
    this.partName = 'Faucet';
    this.homePageTitle = 'Faucets';
    this.translateId = "visualizer.bathroom.vanity.vanity_faucet";
    this.visible = [Vanity.Types.Custom];
    this.useMatchesFailedNavigation = true;
    if (Config.isDevMode()) {
      this.canBeDisabled = true;
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["SinkSize"]) {
      dbFeature.metaData["SinkSize"] = [METADATA.Inner]
    } else if(dbFeature.metaData["SinkSize"].includes(METADATA.Outer) && !dbFeature.metaData["SinkSize"].includes(METADATA.Inner)) (
      dbFeature.metaData["SinkSize"].push(METADATA.Inner)
    )
    return this.load_(dbFeature, new VanityFaucet());
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  getCurrentSinkSize() {
    const sinkParent = this.getParent().sink;
    if (sinkParent && sinkParent.activeFeature) {
      const sinkMeta = sinkParent.activeFeature.metaData["SinkSize"];
      if (sinkMeta) {
        return Array.isArray(sinkMeta) ? sinkMeta[0] : sinkMeta
      } else if (sinkParent.activeFeature.partName.includes("Placeholder")) {
        return "Outer"
      }
    }
    return null
  }

  getArrayOfConditions(withSinkSize = true) {
    // const counterTopSize = this.getParent().counterTopSize();
    // const conditions = [{
    //   propName: 'VanitySize',
    //   propValue: counterTopSize
    // }];
    const conditions = super.getArrayOfConditions();
    if (withSinkSize && this.getCurrentSinkSize()) {
      conditions.push({
        propName: 'SinkSize',
        propValue: this.getCurrentSinkSize()
      })
    }
    const vanityParent = this.getParent();
    const countertopSize = vanityParent.getCounterTopSize();
    if (countertopSize) {
      conditions.push({
        propName: "VanitySize",
        propValue: countertopSize && countertopSize[0] && (countertopSize[0] === "32") ? "48" : countertopSize
      })
    }
    const sinkType = vanityParent.sink && vanityParent.sink.activeFeature && vanityParent.sink.activeFeature.metaData["SinkType"]
    if (sinkType) {
      conditions.push({
        propName: "SinkType",
        propValue: vanityParent.sink.activeFeature.metaData["SinkType"]
      })
    }
    // console.log("conditions", conditions);
    return conditions;
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions(true)))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getAvailableFeatures() {
    return filter(this.features, f => f.matchesMetaForCondition('VanitySize', this.getParent().counterTopSize()));
  }

  handleChangeParent(nonCompatibleWith) {
    if (nonCompatibleWith === "sink") {
      this.getParent().getParent().sink.setActiveFeatureByFilter("SinkSize", "Inner")
    } else {
      this.getParent().getParent().vanityCabinet.setActiveFeatureByFilter("Size", this.metaData["VanitySize"] ? this.metaData["VanitySize"][0] : null); // "60in", etc.
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.Vanity.Faucet;
      }
    }
  }
}
